import { forwardRef, type InputHTMLAttributes } from "react";
import { cn } from "@/lib/cn";

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  hint?: string;
  /** Default true: Feld (inkl. Wrapper) nimmt die volle verfügbare Breite ein — passend für
   * Formulare. In Filterleisten (flex-wrap nebeneinander) auf false setzen und die Breite des
   * Feldes selbst über `className` (z. B. "w-40") steuern, sonst beansprucht jedes Feld eine
   * eigene Zeile. */
  fullWidth?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, label, hint, id, fullWidth = true, ...props },
  ref,
) {
  const inputId = id ?? props.name;
  return (
    <div className={fullWidth ? "w-full" : "shrink-0"}>
      {label && (
        <label htmlFor={inputId} className="label">
          {label}
        </label>
      )}
      <input
        ref={ref}
        id={inputId}
        className={cn(
          "bg-bg-input border border-border rounded px-3 py-2 text-sm text-text-primary",
          "placeholder:text-text-tertiary focus:border-border-accent focus:ring-1 focus:ring-accent/30",
          fullWidth && "w-full",
          className,
        )}
        {...props}
      />
      {hint && <p className="mt-1 text-xs text-text-tertiary">{hint}</p>}
    </div>
  );
});
